export function mergeMaintenanceRecord(record, overlay) {
  const update = overlay?.version === 1 ? overlay.places?.[record.id] : null;
  if (!update?.attributes) return record;
  const attributes = { ...record.attributes, ...update.attributes };
  const disputed = Object.values(attributes).some((attribute) =>
    ["stale", "needs-review"].includes(maintenanceStatus(attribute)),
  );
  return { ...record, ...(disputed ? { summary: null } : {}), attributes };
}

export function maintenanceStatus(attribute, now = Date.now()) {
  if (attribute?.maintenanceStatus === "needs-review") return "needs-review";
  if (!attribute?.checkedAt) return "legacy";
  const checked = Date.parse(attribute.checkedAt);
  const expires = Date.parse(attribute.expiresAt);
  if (
    !Number.isFinite(checked) ||
    !Number.isFinite(expires) ||
    checked > now + 60000 ||
    expires <= now ||
    expires <= checked
  )
    return "stale";
  return "checked";
}
